export class StorageKeys {

  static AUTH_TOKEN = 'chronos-auth-token';

}
